import React, { useEffect, useState } from 'react'
import axios from "axios"
import InnerStyles from './InnerStyles.module.css'
import { NavLink } from 'react-router-dom'

const Treatments = () => {
  const [data, setData] = useState([])

  useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/uploads`)
    .then((res)=>{
       setData(res.data)
    })
    .catch(err=>{
      alert("unable to fetch the Treatment data")
    })
    

    

  })
  return (
    <main>
      <section className={InnerStyles.breadgum}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
                         <h1>Treatments</h1>

            </div>
          </div>

        </div>

      </section>

      <section className={`py-5 bx_shadow`}>
        <div className='container'>
          <div className='row'>
          {
            data.map((treatments)=>{
              return(
                <div className='col-md-3' key={treatments._id}>
                  <div className='mb-3'>
                     <img 
  src={`https://backendsurgylife-1.onrender.com/${treatments.filename}`} 
  alt={treatments.tname} 
  className="img-fluid rounded"
/>
                    <h6 className={'my-3 text-center'}>
                      <NavLink className={InnerStyles.navtreatments} to='/subtreatments'>{treatments.tname}</NavLink>
                      </h6>
                  </div>
                </div>
              )
            })
          }
          </div>
        </div>
      </section>

    </main>
  )
}

export default Treatments














// import Table from "react-bootstrap/Table"

//  <Table striped bordered hover>
//       <thead>
//         <tr>
//           <th>Name</th>
//          <th>Email</th>
//           <th>Phone</th>
//           <th>Address</th>

          
//         </tr>
//       </thead>

//       <tbody>
//          {
//           patientData.map((patient)=>{
//           return(
//             <tr>
//               <td>{patient.name}</td>
//               <td>{patient.email}</td>
//               <td>{patient.phone}</td>
//               <td>{patient.address}</td>

//             </tr>
//           )
//           })
//          }
//           </tbody>
//     </Table>
